// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';

import { apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet } from '../../../api/remote-api/.tube.generated/fn/system-history/api-system-history-datasourceupdatestatus-system-serial-number-system-material-number-get';
import { apiSystemHistoryMarkersGet } from '../../../api/remote-api/.tube.generated/fn/system-history/api-system-history-markers-get';
import { apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet } from '../../../api/remote-api/.tube.generated/fn/system-history/api-system-history-system-serial-number-system-material-number-ticket-number-get';
import {
  MapApiService,
  keyBySerialAndMaterialNumber,
} from '../../shared/services/map-api.service';

@Injectable({
  providedIn: 'root',
})
export class TubeService {
  /** GET marker table from the server */
  markers = this.mapApiService.mapEndpoint(apiSystemHistoryMarkersGet);

  /** GET system history by system serial number. */
  // TODO: tube API Spec is BROKEN!!
  systemHistory = this.mapApiService.mapEndpoint(
    apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet
  );

  /* GET TubeStatus */
  dataSourceUpdateStatus = this.mapApiService.mapEndpoint(
    apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet,
    {
      customCacheKey: keyBySerialAndMaterialNumber,
    }
  );

  constructor(private mapApiService: MapApiService) {}
}
